import {E, T, wsClient} from '../imports';

/**
 * BalancesManager is a singleton that manages the user's account balances.
 * It handles WebSocket messages for balances updates (GET_BALANCES, UPDATE_BALANCES).
 */
class BalancesManager {
    balances: T.Balances | null = null;

    // TODO this is legacy from portfolioManager... where can we move this? profile?
    isConnected: boolean = false;

    // Callback fired when balances update
    onBalancesUpdated: ((balances: T.Balances | null) => void) | null = null;


    /**
     * Initialize balances by requesting current data from server.
     * Should be called after WebSocket connection is established.
     */
    init = async (): Promise<void> => {
        // Register callback with WsClient
        wsClient.onBalancesUpdate = this.handleBalancesUpdate;

        try {
            const balancesData = await wsClient.sendRequest(
                E.WsRoute.BALANCES,
                E.WsBalancesCommand.GET,
                undefined,
                60
            );

            this.balances = balancesData as T.Balances;
            this.isConnected = true;
            this.onBalancesUpdated?.(this.balances);
        } catch (error) {
            console.error('[BalancesManager] Failed to load balances:', error);
            throw error;
        }
    };

    /**
     * Disconnect and clear balances data.
     */
    disconnect = () => {
        this.balances = null;
        this.isConnected = false;
        this.onBalancesUpdated?.(this.balances);
        console.log('[BalancesManager] Disconnected and cleared balances');
    };

    /**
     * Handle incoming WebSocket push messages for balances updates.
     * Server sends full or partial balance updates.
     */
    handleBalancesUpdate = (payload: Partial<T.Balances>) => {
        if (!this.balances) {
            // First update - set full data
            this.balances = payload as T.Balances;
        } else {
            // Delta update - merge changed fields
            this.balances = { ...this.balances, ...payload };
        }
        
        this.onBalancesUpdated?.(this.balances);
        console.log('[BalancesManager] Balances updated:', this.balances);
    };
}

export const balancesManager = new BalancesManager();
